export const ISSN_PATTERN_STRING = '^\\d{4}-?\\d{3}[0-9Xx]$';

export const ISSN_PATTERN = new RegExp(ISSN_PATTERN_STRING);

export function matchesIssnPattern(input: string): boolean {
  return ISSN_PATTERN.test(input.trim());
}

/**
 * Validates ISSN check digit using mod-11 (weights 8–2 on first 7 digits).
 * Non-digit characters between digit positions are ignored (e.g. hyphens).
 * Returns normalized 8-character ISSN (7 digits + check) or null if invalid.
 */
export function validateIssnDigits(
  issn: string | null | undefined
): string | null {
  let valid = false;
  let n = '';
  let state = 0;
  let sum = 0;
  const l = issn == null ? 0 : issn.length;

  for (let i = 0; i < l; i++) {
    const c = issn!.charAt(i);
    switch (state) {
      case 0:
        if (c >= '0' && c <= '9') {
          n += c;
          sum += 8 * (c.charCodeAt(0) - '0'.charCodeAt(0));
          state = 1;
        }
        break;
      case 1:
        if (c >= '0' && c <= '9') {
          n += c;
          sum += 7 * (c.charCodeAt(0) - '0'.charCodeAt(0));
          state = 2;
        }
        break;
      case 2:
        if (c >= '0' && c <= '9') {
          n += c;
          sum += 6 * (c.charCodeAt(0) - '0'.charCodeAt(0));
          state = 3;
        }
        break;
      case 3:
        if (c >= '0' && c <= '9') {
          n += c;
          sum += 5 * (c.charCodeAt(0) - '0'.charCodeAt(0));
          state = 4;
        }
        break;
      case 4:
        if (c >= '0' && c <= '9') {
          n += c;
          sum += 4 * (c.charCodeAt(0) - '0'.charCodeAt(0));
          state = 5;
        }
        break;
      case 5:
        if (c >= '0' && c <= '9') {
          n += c;
          sum += 3 * (c.charCodeAt(0) - '0'.charCodeAt(0));
          state = 6;
        }
        break;
      case 6:
        if (c >= '0' && c <= '9') {
          n += c;
          sum += 2 * (c.charCodeAt(0) - '0'.charCodeAt(0));
          state = 7;
        }
        break;
      case 7:
        if (c === '0') {
          n += c;
          valid = sum % 11 === 0;
          state = 8;
        } else if (c >= '1' && c <= '9') {
          n += c;
          valid = 11 - (sum % 11) === c.charCodeAt(0) - '0'.charCodeAt(0);
          state = 8;
        } else if (c === 'X' || c === 'x') {
          n += 'X';
          valid = 11 - (sum % 11) === 10;
          state = 8;
        }
        break;
      case 8:
        if ((c >= '0' && c <= '9') || c === 'X' || c === 'x') {
          valid = false;
        }
        break;
    }
  }

  return valid ? n : null;
}

export function isValidIssnChecksum(input: string): boolean {
  return validateIssnDigits(input.trim()) !== null;
}
